module.exports = __webpack_public_path__ + "img/lognBg.b39c874f.png";